<template>
  <div class="childtrackingsystem-forms">
    <div
      v-if="isLoading"
      class="row bg-white"
    >
      <div class="col-12 text-center">
        <img
          src="../../assets/img/loading.gif"
          alt="Loading"
          style="width: 80px; height: 80px;"
        >
      </div>
    </div>
    <div
      v-if="!isContent"
      class="row bg-white pt-3 pb-3"
    >
      <div class="col-md-4">
        <label
          class="form-label"
          for="selectedMentor"
        >Invuller</label>
        <input
          type="search"
          class="form-select form-select-sm"
          id="mentor"
          placeholder="Zoek..."
          name="mentor"
          list="mentors-list"
          v-model="searchedMentor"
          @focus="searchedMentor = ''; document.getElementById('mentors-list').style.display='block';"
          @change="searchResults()"
        />
        <datalist id="mentors-list">
          <option value="Alle" selected></option>
          <option
            v-for="mentor in mentors"
            :value="mentor.name"
            :key="mentor.id"
          >
          </option>
        </datalist>
      </div>
      <div class="col-md-4">
        <label
          class="form-label"
          for="selectedList"
        >Observatieformulier</label>
        <input
          type="search"
          class="form-select form-select-sm"
          id="selectedList"
          placeholder="Zoek..."
          name="selectedList"
          list="lists-list"
          v-model="searchedList"
          @focus="searchedList = ''; document.getElementById('lists-list').style.display='block';"
          @change="searchResults()"
        />
        <datalist id="lists-list">
          <option value="Alle" selected></option>
          <option
            v-for="list in lists"
            :key="list.id"
            :value="list.title"
          >
          </option>
        </datalist>
      </div>
      <div class="col-md-4">
        <label
          class="form-label"
          for="selectedMentor"
        >Filter kinderen</label>
        <select
          class="form-select form-select-sm"
          id="filterChildren"
          name="filterChildren"
          v-model="filterChildren"
          @change="getChildObservationForms()"
        >
          <option value="all">Alle</option>
          <option value="present">Aanwezig</option>
          <option value="vve">VVE</option>
        </select>
      </div>
    </div>
    <div
      v-if="!isContent"
      class="row bg-white"
    >
      <div class="col-12">
        <table class="table">
          <thead>
            <tr>
              <th>Observatieformulier <span
                data-bs-toggle="modal"
                data-bs-target="#infoModal"
              ><icon name="info"></icon>
                        </span>
              </th>
              <th class="text-end pe-1">
                <button
                  class="btn btn-sm btn-outline-danger"
                  @click="getChildObservationForms(false)"
                  v-if="showActive"
                >Ga naar archief
                </button>
                <button
                  class="btn btn-sm btn-outline-success"
                  @click="getChildObservationForms(true)"
                  v-if="!showActive"
                >Verlaat archief
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-bind:key="key"
              v-for="(form, key) in filteredRows"
            >
              <td>
                <span class="fw-bold">{{ form.listTitle }}</span> van kind <span class="fw-bold">{{ form.childName }}</span>
                ({{ form.childAge }}) opgeslagen op {{ form.date }}
                <span v-if="viewStatus">(status: {{ form.status }})</span>
              </td>
              <td class="text-end pe-1">
                      <span
                        style="margin-top: 5px; margin-right: 15px;color:#666;"
                        title="Bekijk"
                        @click="openChildForm(form.idResult, form.idChildForm)"
                      >
                        <icon name="look-into"></icon>
                      </span>
                <span
                  style="margin-top: 5px; margin-right: 15px;"
                  title="Print naar pdf"
                  @click="printChildForm(form.idChildForm);"
                >
                          <icon name="file-pdf"></icon>
                      </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="isContent">
      <childtrackingsystem-observationform
        :idResult="selectedResult"
        :idChildForm="selectedChildForm"
      ></childtrackingsystem-observationform>
    </div>

    <div
      class="modal fade"
      id="infoModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-3">
                <icon name="look-into"></icon>
              </div>
              <div class="col-9">Bekijk observatieformulier</div>
            </div>
            <div class="row">
              <div class="col-3">
                <icon name="file-pdf"></icon>
              </div>
              <div class="col-9">Print observatieformulier</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ChildtrackingsystemObservationform from "./ObservationForm";
import icon from "@/components/Icon.vue";
import { downloadBase64File } from '@/helpers/DownloadFile.js'

export default {
  name: 'childtrackingsystem-forms',
  components: { icon, ChildtrackingsystemObservationform },
  props: [],
  data() {
    return {
      isContent: false,
      isLoading: false,
      lists: [],
      selectedList: 0,
      searchedList: 'Alle',
      mentors: [],
      searchedMentor: 'Alle',
      selectedMentor: 0,
      filterChildren: 'all',
      childId: null,
      childName: null,
      listId: null,
      formId: null,
      resultId: null,
      forms: [],
      childrenCTS: [],
      showActive: true,
      isModalInfo: false,
      viewStatus: true,
      selectedResult: 0,
      selectedChildForm: 0
    };
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken;
    },
    session() {
      return this.$store.getters.session;
    },
    filteredRows() {
      return this.$store.getters.globalChildByTextFilter ? this.forms.filter(form => form.childName.toLowerCase().includes(this.$store.getters.globalChildByTextFilter.toLowerCase())) : this.forms;
    }
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    };
    this.getChildObservationForms(true);
  },
  methods: {
    getChildObservationForms(active) {
      this.isLoading = true;
      if (this.showActive !== active) {
        this.mentors = []
        this.lists = []
      }
      this.showActive = active;
      this.$store.commit('REGISTER_ACTIVE_REQUEST');
      this.$request.post('/ChildTrackingSystem/forms', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        selectedMentor: this.selectedMentor,
        selectedList: this.selectedList,
        selectedFilterChildren: this.filterChildren,
        showActive: this.showActive
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST');
        if (response.forms) {
          this.forms = response.forms;
          this.viewStatus = response.viewStatus;
          if (this.lists.length < 1) {
            this.lists = response.lists;
          }
          if (this.mentors.length < 1) {
            this.mentors = response.mentors;
          }
          this.isLoading = false;
        }
      });
    },
    searchResults() {
      if (this.searchedMentor === 'Alle') {
        this.selectedMentor = 0;
      } else {
        this.mentors.forEach(mentor => {
          if (mentor.name.toLowerCase().includes(this.searchedMentor.toLowerCase())) {
            this.selectedMentor = mentor.id
          }
        })
      }
      if (this.searchedList === 'Alle') {
        this.selectedList = 0;
      } else {
        this.lists.forEach(list => {
          if (list.title.toLowerCase().includes(this.searchedList.toLowerCase())) {
            this.selectedList = list.id
          }
        })
      }
      document.activeElement.blur()
      this.getChildObservationForms(this.showActive);
    },
    printChildForm(idChildForm, childId, listId, idResult, formId) {
      this.isLoading = true;
      this.$store.commit('REGISTER_ACTIVE_REQUEST');
      this.$request.post('/ChildTrackingSystem/downloadChildForm', {
        idChildForm: idChildForm,
        idForm: formId,
        idChild: childId,
        idList: listId,
        idResult: idResult,
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        answerOption: 'last'
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST');
        if (response) {
          this.download(response.filename, response.fileContent);
        } else {
          this.isLoading = false;
        }
      });
    },
    download(filename, fileContent) {
      downloadBase64File(filename, fileContent);
      this.isLoading = false;
    },
    openChildForm(idResult, idChildForm) {
      this.isContent = true;
      this.selectedResult = idResult;
      this.selectedChildForm = idChildForm;
    }
  }
};
</script>

<style scoped>
.modalLoader {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 100px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.table {
  width: 100%;
}

.table th {
  color: #666;
  background-color: #f0f0f5;
  border-top: 1px solid #ddd !important;
}

.table td {
  border-bottom: 1px solid #ddd !important;
  color: #666;
}
</style>
